import React from 'react'
import { useContext ,useEffect} from 'react'
import notecontext from '../context/notes/Notecontext'
export default function About() {

  return (
    <div>
      <h1 className="mb-4 text-center">About iNotebook</h1>
      <p className="lead text-center" style={{maxWidth:'600px',margin:'0 auto',color:'#6366f1'}}>
        iNotebook is a modern, cloud-based note-taking app. Securely create, edit, and manage your notes from anywhere. Built with React and a beautiful UI for productivity and ease of use.
      </p>
    </div>
  )
}
